import { useEffect } from "react";
import React, { Component } from 'react';
import { useNavigate } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import './tags.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'

const UserManagement = () => {
    function AddUser(props) {
        return (
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add User
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-1 " controlId="formBasicEmail">
                            <Form.Label>Profile</Form.Label>
                            <Form.Control type="file" placeholder="Enter username" />
                        </Form.Group>
                        <Form.Group className="mb-1 " controlId="formBasicEmail">
                            <Form.Label>Username</Form.Label>
                            <Form.Control type="text" placeholder="Enter username" />
                        </Form.Group>
                        <Form.Group className="mb-1 " controlId="formBasicEmail">
                            <Form.Label>Organization</Form.Label>
                            <Form.Select aria-label="Default select example">
                                <option>Select Organization</option>
                                <option value="1">TCS</option>
                                <option value="2">Infosys</option>
                                <option value="3">Wipro</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-1" controlId="formBasicEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="text" placeholder="Enter email" />
                        </Form.Group>
                        <Form.Group className="mb-1" controlId="formBasicEmail">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control type="text" placeholder="Enter phone" />
                        </Form.Group>

                        <Form.Group className="mb-1" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password" />
                        </Form.Group>


                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                    <Button onClick={props.onHide}>Close</Button>

                </Modal.Footer>
            </Modal>
        );
    }
    function EditUser(props) {
        return (
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit User
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-1 " controlId="formBasicEmail">
                            <Form.Label>Profile</Form.Label>
                            <Form.Control type="file" placeholder="Enter username" />
                        </Form.Group>
                        <Form.Group className="mb-1 " controlId="formBasicEmail">
                            <Form.Label>Username</Form.Label>
                            <Form.Control type="text" placeholder="Enter username" />
                        </Form.Group>
                        <Form.Group className="mb-1 " controlId="formBasicEmail">
                            <Form.Label>Organization</Form.Label>
                            <Form.Select aria-label="Default select example">
                                <option>Select Organization</option>
                                <option value="1">TCS</option>
                                <option value="2">Infosys</option>
                                <option value="3">Wipro</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-1" controlId="formBasicEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="text" placeholder="Enter email" />
                        </Form.Group>
                        <Form.Group className="mb-1" controlId="formBasicEmail">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control type="text" placeholder="Enter phone" />
                        </Form.Group>

                        <Form.Group className="mb-1" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password" />
                        </Form.Group>


                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        Update
                    </Button>
                    <Button onClick={props.onHide}>Close</Button>

                </Modal.Footer>
            </Modal>
        );
    }
    function DeleteUser(props) {
        return (
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Delete User
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure? You want to delete.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        Delete
                    </Button>
                    <Button onClick={props.onHide}>Close</Button>

                </Modal.Footer>
            </Modal>
        );
    }
    // <BootstrapSwitchButton
    //     checked={false}
    //     onlabel='Admin User'
    //     offlabel='Regular User'
    //     onChange={(checked: boolean) => {
    //         this.setState({ isUserAdmin: checked })
    //     }}
    // />
    const [modalShow, addModelShow] = React.useState(false);
    const [editModel, editModelShow] = React.useState(false);
    const [deleteModel, deleteModelShow] = React.useState(false);

    return <div style={{ display: 'block', }} className="maindev">

        <div className='container_main '>
            <div className="col-md-12 text-right ">
                <Button className='tagsbtn btn_cls' onClick={() => addModelShow(true)} >Add User</Button>
                <AddUser
                    show={modalShow}
                    onHide={() => addModelShow(false)}
                />
                <EditUser
                    show={editModel}
                    onHide={() => editModelShow(false)}
                />
                <DeleteUser
                    show={deleteModel}
                    onHide={() => deleteModelShow(false)}
                />
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Table striped hover responsive="md">
                        <thead>
                            <tr>
                                <th>Profile</th>
                                <th>UserName</th>
                                <th>Organization</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Permission</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td><img height={'65px'} width={'65px'} src="/images/user.png" alt="" /></td>
                                <td>Amit Kumar</td>
                                <td>Infosys</td>
                                <td>amit@gmail.com</td>
                                <td >6394568956</td>
                                <td><button className="btn_user" ><i className="fa fa-eye" ></i></button> <button className="btn_user" ><i className="fa fa-edit"></i></button></td>
                                <td><button className="btn_user" onClick={() => editModelShow(true)}><i className="fa fa-edit" ></i></button> <button className="btn_user" onClick={() => deleteModelShow(true)}><i className="fa fa-trash"></i></button> <BootstrapSwitchButton checked={true} onstyle="success" onlabel="OK" offlabel="Block" size="sm" />    </td>
                            </tr>
                            <tr>
                                <td><img height={'65px'} width={'65px'} src="/images/user.png" alt="" /></td>
                                <td>Amit Kumar</td>
                                <td>Infosys</td>
                                <td>amit@gmail.com</td>
                                <td >6394568956</td>
                                <td><button className="btn_user" ><i className="fa fa-eye" ></i></button> <button className="btn_user" ><i className="fa fa-edit"></i></button>  </td>
                                <td><button className="btn_user" onClick={() => editModelShow(true)}><i className="fa fa-edit" ></i></button> <button className="btn_user" onClick={() => deleteModelShow(true)}><i className="fa fa-trash"></i></button> <BootstrapSwitchButton checked={true} onstyle="success" onlabel="OK" offlabel="Block" size="sm" /></td>
                            </tr>
                            <tr>
                                <td><img height={'65px'} width={'65px'} src="/images/user.png" alt="" /></td>
                                <td>Amit Kumar</td>
                                <td>Infosys</td>
                                <td>amit@gmail.com</td>
                                <td >6394568956</td>
                                <td><button className="btn_user" ><i className="fa fa-eye" ></i></button> <button className="btn_user" ><i className="fa fa-edit"></i></button> </td>
                                <td><button className="btn_user" onClick={() => editModelShow(true)}><i className="fa fa-edit" ></i></button> <button className="btn_user" onClick={() => deleteModelShow(true)}><i className="fa fa-trash"></i></button> <BootstrapSwitchButton checked={true} onstyle="success" onlabel="OK" offlabel="Block" size="sm" /></td>
                            </tr>
                            <tr>
                                <td><img height={'65px'} width={'65px'} src="/images/user.png" alt="" /></td>
                                <td>Amit Kumar</td>
                                <td>Infosys</td>
                                <td>amit@gmail.com</td>
                                <td >6394568956</td>
                                <td><button className="btn_user" ><i className="fa fa-eye" ></i></button> <button className="btn_user" ><i className="fa fa-edit"></i></button> </td>
                                <td><button className="btn_user" onClick={() => editModelShow(true)}><i className="fa fa-edit" ></i></button> <button className="btn_user" onClick={() => deleteModelShow(true)}><i className="fa fa-trash"></i></button> <BootstrapSwitchButton checked={true} onstyle="success" onlabel="OK" offlabel="Block" size="sm" /></td>
                            </tr>

                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    </div>



};

export default UserManagement;
